<template>
    <div class="register-form p-lg-4 p-sm-2">
        <div class="form-header">
            <div class="d-flex justify-content-center header-logo">
                <img
                    class="sticky-img"
                    width="100"
                    src="../../assets/img/logo-daring.png"
                    alt="Logo"
                />
            </div>
        </div>
        <div class="form-body py-lg-4 py-sm-2">
            <b-card no-body>
                <b-tabs card fill>
                    <b-tab title="Warga Belajar" @click="changeTab('murid')" :title-item-class="'tab-title'" active>
                        <b-form data-vv-scope="murid-form">
                            <div role="group" class="py-2">
                                <!-- <label for="input-username">Username</label> -->
                                <b-form-input
                                    id="input-username"
                                    class="form-login"
                                    name="username"
                                    data-vv-as="Username"
                                    v-model="reg_student_form.username"
                                    type="text"
                                    placeholder="Username"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <span :class="{ 'error-validation': errors.first('murid-form.username') }">{{ errors.first('murid-form.username') }}</span>
                            </div>
                            <div role="group" class="py-2">
                                <!-- <label for="input-fullname">Nama Lengkap</label> -->
                                <b-form-input
                                    id="input-fullname"
                                    class="form-login"
                                    name="fullname"
                                    data-vv-as="Nama lengkap"
                                    v-model="reg_student_form.full_name"
                                    type="text"
                                    placeholder="Nama Lengkap"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <span :class="{ 'error-validation': errors.first('murid-form.fullname') }">{{ errors.first('murid-form.fullname') }}</span>
                            </div>
                            <div role="group" class="py-2">
                                <!-- <label for="input-email">Email</label> -->
                                <b-form-input
                                    id="input-email"
                                    class="form-login"
                                    name="email"
                                    data-vv-as="Email"
                                    v-model="reg_student_form.email"
                                    type="email"
                                    placeholder="Email"
                                    v-validate="'required|email'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <span :class="{ 'error-validation': errors.first('murid-form.email') }">{{ errors.first('murid-form.email') }}</span>
                            </div>
                            <div role="group" class="py-2">
                                <!-- <label for="input-password">Kata Sandi</label> -->
                                <b-input-group>
                                <b-form-input
                                    id="input-password"
                                    ref="muridPassword"
                                    class="form-login"
                                    name="password"
                                    data-vv-as="Password"
                                    v-model="reg_student_form.password"
                                    :type="!reg_student_form.showPassword ? 'password' : 'text'"
                                    placeholder="Kata Sandi"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <b-input-group-append @click="reg_student_form.showPassword = !reg_student_form.showPassword" style="cursor: pointer;">
                                    <b-input-group-text>
                                        <b-icon :icon="reg_student_form.showPassword ? 'eye-slash' : 'eye'" />
                                    </b-input-group-text>
                                </b-input-group-append>
                                </b-input-group>
                                <span :class="{ 'error-validation': errors.first('murid-form.password') }">{{ errors.first('murid-form.password') }}</span>
                            </div>
                            <div role="group" class="py-2">
                                <!-- <label for="input-password-confirmation">Kata Ulang Sandi</label> -->
                                <b-input-group>
                                <b-form-input
                                    id="input-password-confirmation"
                                    class="form-login"
                                    name="password_confirmation"
                                    data-vv-as="Ulang kata sandi"
                                    v-model="reg_student_form.password_confirmation"
                                    :type="!reg_student_form.showPasswordConfirmation ? 'password' : 'text'"
                                    placeholder="Ulang Kata Sandi"
                                    v-validate="'required|confirmed:muridPassword'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <b-input-group-append @click="reg_student_form.showPasswordConfirmation = !reg_student_form.showPasswordConfirmation" style="cursor: pointer;">
                                    <b-input-group-text>
                                        <b-icon :icon="reg_student_form.showPasswordConfirmation ? 'eye-slash' : 'eye'" />
                                    </b-input-group-text>
                                </b-input-group-append>
                                </b-input-group>
                                <span :class="{ 'error-validation': errors.first('murid-form.password_confirmation') }">{{ errors.first('murid-form.password_confirmation') }}</span>
                            </div>
                            <div role="group" class="py-2">
                                <!-- <label for="input-class-code">Kode Kelas</label> -->
                                <b-form-input
                                    id="input-class-code"
                                    class="form-login"
                                    name="class-code"
                                    data-vv-as="Kode kelas"
                                    v-model="reg_student_form.class_code"
                                    type="text"
                                    placeholder="Kode Kelas"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <span :class="{ 'error-validation': errors.first('murid-form.class-code') }">{{ errors.first('murid-form.class-code') }}</span>
                            </div>
                            <div role="group" class="py-2">
                                <!-- <label for="input-class-code">Kode Kelas</label> -->
                                <b-form-select
                                    v-model="reg_student_form.tahun_ajaran_id"
                                    name="tahun_ajaran_id"
                                    v-validate="'required'"
                                    value-field="id"
                                    placeholder="Tahun Ajaran"
                                    text-field="name"
                                    data-vv-as="Tahun Ajaran"
                                    :options="taList"
                                >
                                    <b-form-select-option :value="null" disabled>Pilih Tahun Ajaran</b-form-select-option>
                                </b-form-select>
                                <span :class="{ 'error-validation': errors.first('murid-form.tahun_ajaran_id') }">{{ errors.first('murid-form.tahun_ajaran_id') }}</span>
                            </div>
                        </b-form>
                    </b-tab>
                    <b-tab title="Tutor" @click="changeTab('tutor')" :title-item-class="'tab-title'">
                        <b-form data-vv-scope="tutor-form">
                            <div role="group" class="py-2">
                                <!-- <label for="input-tutor-username">Username</label> -->
                                <b-form-input
                                    id="input-tutor-username"
                                    class="form-login"
                                    name="username"
                                    data-vv-as="Username"
                                    v-model="reg_tutor_form.username"
                                    type="text"
                                    placeholder="Username"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <span :class="{ 'error-validation': errors.first('tutor-form.username') }">{{ errors.first('tutor-form.username') }}</span>
                            </div>
                            <div role="group" class="py-2">
                                <!-- <label for="input-tutor-fullname">Nama Lengkap</label> -->
                                <b-form-input
                                    id="input-tutor-fullname"
                                    class="form-login"
                                    name="fullname"
                                    data-vv-as="Nama lengkap"
                                    v-model="reg_tutor_form.full_name"
                                    type="text"
                                    placeholder="Nama Lengkap"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <span :class="{ 'error-validation': errors.first('tutor-form.fullname') }">{{ errors.first('tutor-form.fullname') }}</span>
                            </div>
                            <div role="group" class="py-2">
                                <!-- <label for="input-tutor-email">Email</label> -->
                                <b-form-input
                                    id="input-tutor-email"
                                    class="form-login"
                                    name="email"
                                    data-vv-as="Email"
                                    v-model="reg_tutor_form.email"
                                    type="email"
                                    placeholder="Email"
                                    v-validate="'required|email'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <span :class="{ 'error-validation': errors.first('tutor-form.email') }">{{ errors.first('tutor-form.email') }}</span>
                            </div>
                            <div role="group" class="py-2">
                                <!-- <label for="input-tutor-password">Kata Sandi</label> -->
                                <b-input-group>
                                <b-form-input
                                    id="input-tutor-password"
                                    ref="password"
                                    class="form-login"
                                    name="password"
                                    data-vv-as="Password"
                                    v-model="reg_tutor_form.password"
                                    :type="!reg_tutor_form.showPassword ? 'password' : 'text'"
                                    placeholder="Kata Sandi"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <b-input-group-append @click="reg_tutor_form.showPassword = !reg_tutor_form.showPassword" style="cursor: pointer;">
                                    <b-input-group-text>
                                        <b-icon :icon="reg_tutor_form.showPassword ? 'eye-slash' : 'eye'" />
                                    </b-input-group-text>
                                </b-input-group-append>
                                </b-input-group>
                                <span :class="{ 'error-validation': errors.first('tutor-form.password') }">{{ errors.first('tutor-form.password') }}</span>
                            </div>
                            <div role="group" class="py-2">
                                <!-- <label for="input-tutor-password-confirmation">Kata Ulang Sandi</label> -->
                                <b-input-group>
                                <b-form-input
                                    id="input-tutor-password-confirmation"
                                    class="form-login"
                                    name="password_confirmation"
                                    data-vv-as="Ulang kata sandi"
                                    v-model="reg_tutor_form.password_confirmation"
                                    :type="!reg_tutor_form.showPasswordConfirmation ? 'password' : 'text'"
                                    placeholder="Kata Ulang Sandi"
                                    v-validate="'required|confirmed:password'"
                                    trim
                                    autocomplete="off"
                                ></b-form-input>
                                <b-input-group-append @click="reg_tutor_form.showPasswordConfirmation = !reg_tutor_form.showPasswordConfirmation" style="cursor: pointer;">
                                    <b-input-group-text>
                                        <b-icon :icon="reg_tutor_form.showPasswordConfirmation ? 'eye-slash' : 'eye'" />
                                    </b-input-group-text>
                                </b-input-group-append>
                                </b-input-group>
                                <span :class="{ 'error-validation': errors.first('tutor-form.password_confirmation') }">{{ errors.first('tutor-form.password_confirmation') }}</span>
                            </div>
                        </b-form>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
        <div class="form-footer">
            <div v-if="showLoader">
                <div class="text-center text-danger my-2">
                    <img class="img-loading" src="../../assets/img/logo-daring.png" alt="Logo"/><br>
                    <b-spinner class="align-middle"></b-spinner>
                </div>
            </div>
            <div v-else class="row py-2">
                <div class="col-6">
                    <b-button type="submit" variant="primary" size="md" style="width: 100%;" @click.prevent="register()" >DAFTAR</b-button>
                </div>
                <div class="col-6">
                    <b-button type="button" variant="outline-danger" size="md" style="width: 100%;" @click="hideModalRegister">BATAL</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
    // import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
	export default {
		components: {
            // SquareLoader
		},
		data() {
			return {
                userType: 'murid',
				reg_student_form: {
                    username: null,
                    full_name: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                    class_code: null,
                    tahun_ajaran_id: null,
                    type: 'murid',
                    showPassword: false,
                    showPasswordConfirmation: false
				},
				reg_tutor_form: {
                    username: null,
                    full_name: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                    class_code: null,
                    tahun_ajaran_id: null,
                    type: 'tutor',
                    showPassword: false,
                    showPasswordConfirmation: false
				},
				showLoader: false,
                typeUser: [
                    { value: null, text: 'Pilih tipe user' },
                    { value: 'murid', text: 'Warga Belajar' },
                    { value: 'tutor', text: 'Tutor' },
                ]
			}
		},
        computed: {
            ...mapGetters({
                taList: 'getTaList'
            })
        },
		methods: {
			hideModalRegister() {
                EventBus.$emit('hideModalRegister', true)
			},
            changeTab(val) {
                this.clearRegisterForm()
                this.userType = val
            },
            clearRegisterForm() {
                this.reg_student_form.username = null
                this.reg_student_form.fullname = null
                this.reg_student_form.email = null
                this.reg_student_form.password = null
                this.reg_student_form.password_confirmation = null
                this.reg_student_form.class_code = null
                this.reg_student_form.tahun_ajaran_id = null
                this.reg_tutor_form.username = null
                this.reg_tutor_form.fullname = null
                this.reg_tutor_form.email = null
                this.reg_tutor_form.password = null
                this.reg_tutor_form.password_confirmation = null
                this.reg_tutor_form.class_code = null
                this.reg_tutor_form.tahun_ajaran_id = null
                this.$validator.reset()
            },
			register() {
                let scope = this.userType == 'murid' ? 'murid-form' : 'tutor-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        let form = this.userType == 'murid' ? this.reg_student_form : this.reg_tutor_form
                        this.showLoader = true
						this.$store.dispatch('register', form )
							.then(() => {
								this.showLoader = false
                                this.clearRegisterForm()
                                this.$swal.fire('Success', 'Register success!', 'success')
                                EventBus.$emit('hideModalRegister', true)
							})
							.catch((err)=> {
                                let error = err.response
                                this.showLoader = false
                                if (error.status == 400) {
                                    this.errorValidate(error.data, scope)
                                } else {
                                    this.$swal.fire('Failed', error.data.message, 'error')
                                }
							})
                    }
                });
			},
            async getTaList() {
                this.isBusy = true
				await this.$store.dispatch('getTaListPub')
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			}
		},
		created () {
            this.getTaList();
        }
  }
</script>